(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-hub"]) return;
  try {
    
document.querySelectorAll('[data-sf-blog-hub]').forEach((hub) => {
  const tabs = Array.from(hub.querySelectorAll('[data-blog-filter]'));
  const items = Array.from(hub.querySelectorAll('[data-blog-item]'));

  const applyFilter = (filter) => {
    tabs.forEach((tab) => {
      const active = tab.dataset.blogFilter === filter;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    items.forEach((item) => {
      item.hidden = filter !== 'all' && item.dataset.blogItem !== filter;
    });
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => applyFilter(tab.dataset.blogFilter));
  });

  applyFilter('all');
});

  } catch(e) { console.error(e); }
})();
})();
